<template>
  <div id="root-element" style="background-color: #ffffff">
    <div id="app">
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover"
      >
      <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css">
      <DynamicForm />
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import DynamicForm from './DynamicForm.vue';

export default defineComponent({
  name: 'App',
  components: {DynamicForm},
});
</script>
